<template>
<div style="margin-top: 40px">
  <v-btn fab fixed color="warning" :loading="saveLoad" :disabled="saveLoad" @click.native="save()"><v-icon>mdi-content-save</v-icon></v-btn>
  <h2 style="padding:20px" class="text-center">Kostenvoranschlag</h2>
  <v-layout row wrap>
    <v-flex xs12 xl4 lg4>
      <v-card>
        <v-toolbar class="indigo" dark>
          <v-toolbar-title>Ausstattung</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-combobox filled label="Sarg" v-model="devis.cercueil" :items="liste.cercueil"></v-combobox>
          <v-combobox filled label="Kreuz" v-model="devis.croix" :items="liste.croix"></v-combobox>
          <v-text-field filled suffix="CHF" label="Preis des Kostenvoranschlages" v-model="devis.forfait"></v-text-field>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 xl8 lg8>
      <v-card>
        <v-toolbar class="teal" dark>
          <v-toolbar-title>Dienstleistungen</v-toolbar-title>
        </v-toolbar>
        <v-list>
          <v-list-item v-for="(presta, i) in devis.presta" :key="i">
            <v-list-item-action>
              <v-checkbox v-model="presta.val" style="margin-top:10px"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title :style="!presta.val ? 'text-decoration:line-through' : ''">{{presta.text}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-icon @click="addPresta()" style="margin-top:10px">mdi-plus</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-text-field filled v-model="prestaToAdd" style="width:100%"></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-flex>
    <v-flex xs12 xl8 offset-xl4 lg12>
      <v-card>
        <v-toolbar class="purple" dark>
          <v-toolbar-title>Externe Dienstleistungen</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu>
            <template v-slot:activator="{on, attrs}">
              <v-btn text v-on="on" v-bind="attrs">+ Kremationsgebüren</v-btn>
            </template>
              <v-list>
                <v-list-item @click="addPrestaTiers('Taxe d\'incinération', 'manutention et fourniture d\'une urne de luxe', '', 1170, true)">
                  <v-list-item-title>urne luxe</v-list-item-title>
                </v-list-item>
                <v-list-item @click="addPrestaTiers('Taxe d\'incinération', 'manutention et fourniture d\'une urne spéciale Bio', '', 930, true)">
                  <v-list-item-title>urne Bio</v-list-item-title>
                </v-list-item>
                <v-list-item @click="addPrestaTiers('Taxe d\'incinération', 'manutention et fourniture d\'une urne en bois', '', 870, true)">
                  <v-list-item-title>urne bois</v-list-item-title>
                </v-list-item>
                <v-list-item @click="addPrestaTiers('Taxe d\'incinération', 'manutention et fourniture d\'une urne en métal', '', 770, true)">
                  <v-list-item-title>urne métal</v-list-item-title>
                </v-list-item>
                <v-list-item @click="addPrestaTiers('Taxe d\'incinération', 'manutention et fourniture d\'une urne en location', '', 720, true)">
                  <v-list-item-title>urne location</v-list-item-title>
                </v-list-item>
                <v-list-item @click="addPrestaTiers('Taxe d\'incinération', 'sans urne', '', 690, true)">
                  <v-list-item-title>sans urne</v-list-item-title>
                </v-list-item>
              </v-list>
          </v-menu>
          <v-spacer></v-spacer>
          <v-menu>
            <template v-slot:activator="{on, attrs}">
              <v-btn text v-on="on" v-bind="attrs">+ Todesanzeige</v-btn>
            </template> 
              <v-list>
                <v-list-item @click="addPrestaTiers('Avis Mortuaire', 'La Liberté', '', null, false)">
                  <v-list-item-title>La Liberté</v-list-item-title>
                </v-list-item>
                <v-list-item @click="addPrestaTiers('Avis Mortuaire', 'La Gruyère', '', null, false)">
                  <v-list-item-title>La Gruyère</v-list-item-title>
                </v-list-item>
                <v-list-item @click="addPrestaTiers('Avis Mortuaire', 'Freiburger Nachrichten', '', null, false)">
                  <v-list-item-title>Freiburger Nachrichten</v-list-item-title>
                </v-list-item>
                <v-list-item @click="addPrestaTiers('Avis Mortuaire', '', '', null, false)">
                  <v-list-item-title>Autre</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-spacer></v-spacer>
            <v-menu>
              <template v-slot:activator="{on, attrs}">
                <v-btn text v-on="on" v-bind="attrs">+ Blumen</v-btn>
              </template> 
                <v-list>
                  <v-list-item @click="addPrestaTiers('Fleurs', 'Bouquet main', '', 120, false)">
                    <v-list-item-title>Bouquet main</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="addPrestaTiers('Fleurs', 'Dessus de cercueil', '', 250, false)">
                    <v-list-item-title>Dessus de cercueil</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="addPrestaTiers('Fleurs', 'Couronne', '', 300, false)">
                    <v-list-item-title>Couronne</v-list-item-title>
                  </v-list-item>
                </v-list>
          </v-menu>
          <v-spacer></v-spacer>
          <v-menu>
            <template v-slot:activator="{on, attrs}">
              <v-btn text v-on="on" v-bind="attrs">+ Weiteres</v-btn>
            </template> 
              <v-list>
                <v-list-item @click="addPrestaTiers('Autre', 'Concession / droit d\'entrée', '', 2000, false)">
                  <v-list-item-title>Concession / droit d'entrée</v-list-item-title>
                </v-list-item>
                <v-list-item @click="addPrestaTiers('Autre', 'Faire-part / remerciement', '',  null, true)">
                  <v-list-item-title>Faire-part / remerciement</v-list-item-title>
                </v-list-item>
                <v-list-item @click="addPrestaTiers('Autre', 'Acte de décès', '', 40, true)">
                  <v-list-item-title>Acte de décès</v-list-item-title>
                </v-list-item>
                <v-list-item @click="addPrestaTiers('Autre', '', '', null, false)">
                  <v-list-item-title>Autre</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row v-for="(prestaTier, i) in devis.prestaTiers" :key="i">
                <v-flex xs3>
                  <v-text-field filled @click:prepend="clearFieldPrestaTiers(prestaTier.id)" prepend-icon="mdi-close-box-outline" v-model="prestaTier.categorie"></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field filled v-model="prestaTier.designation"></v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field filled v-model="prestaTier.remarque"></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-text-field filled v-model="prestaTier.prix" label="CHF"></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-checkbox v-model="prestaTier.factPF" style="margin-top:10px" label="$PF"></v-checkbox>
                </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <div class="text-center">
        <v-btn color="primary" :loading="saveLoad" :disabled="saveLoad" @click="save()">Speichern</v-btn>
        <v-menu v-if="showButtonDevis" offset-y>
          <template v-slot:activator="{on, attrs}">
            <v-btn icon ripple v-on="on" v-bind="attrs">
                <v-icon color="primary">mdi-text-box-outline</v-icon>
            </v-btn>
          </template>
            <v-list>
                <v-list-item @click="createDevisPdf()">
                    <v-list-item-title>Etstellen Sie das Kostenvoranschlag im .pdf</v-list-item-title>
                </v-list-item>
                <v-list-item @click="createDevisDocX()">
                    <v-list-item-title>Etstellen Sie das Kostenvoranschlag im .docx</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
      </div>
    </v-flex>
    <v-snackbar :timeout="3000" success v-model="snackbar">Erfolgreich gespeichert !</v-snackbar>
  </v-layout>
</div>
</template>

<script>
    import {ajax_post} from '../../public/global.js'
    export default {
      data(){
        return{
          devis: {
            cercueil: '',
            croix: '',
            forfait: '',
            prestaTiers: [],
            presta: [
              {val: false, text: "Déplacement au lieu de décès, soins au défunt, habillement et mise en bière"},
              {val: false, text: "Transfert du lieu de décès au domicile mortuaire et installation pour présentation"},
              {val: false, text: "Déplacement d'un corbillard au lieu de cérémonie, préparation et convoi au cimetière ou à l'incinération"},
              {val: false, text: "Voiture à fleurs pour le convoi"},
              {val: false, text: "Direction de la cérémonie, porteurs, frais de personnel"},
              {val: false, text: "Formalités complètes de décès"},
              {val: false, text: "Entretien, organisation complète des obsèques, démarches administratives, divers déplacements"},
              {val: false, text: "Levée de corps avec cercueil provisoire, personnel, rétablissement du matériel"},
              {val: false, text: "Retrait des cendres et inhumation de l'urne ou inhumation du corps au cimetière"},
              {val: false, text: "Divers"}
            ]
          },
          liste: {
            cercueil: [
              "Suisse", "acajou", "eben"
            ],
            croix: [
              "cinéraire", "inhumation"
            ]
          },
          prestaToAdd: '',
          snackbar: false,
          saveLoad: false,
          showButtonDevis: false
        }
      },
      methods: {
        addPrestaTiers(cat, text, rema, prix, factPF) {
        let idComment = (Math.max(...this.devis.prestaTiers.map(o => o.id), 0))
        this.devis.prestaTiers.push({categorie: cat, designation: text, remarque: rema, prix: prix, id: idComment + 1, factPF: factPF})
        },
        clearFieldPrestaTiers(id) {
            this.devis.prestaTiers = this.devis.prestaTiers.filter(function (obj){
              return obj.id != id
            })
        },
        saveNext(){
          this.saveLoad = true
          let fieldDevis = JSON.stringify(this.devis)
          ajax_post(`/PHP/ajax/returnSaveDevis.php`, `choice=save&token=${this.$token()}&id=${this.$route.params.id}&devis=${fieldDevis}`).then((response) =>{
            let rep = JSON.parse(response)
            if(!rep.error){
              this.saveLoad = false
              this.showButtonDevis = true
              this.$root.$emit('myinfo', {title: "Serenity", msg: "Sauvegarde réussie !", color: ""})
            }else{
              this.saveLoad = false
              this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
            }
          })
        },
        createDevisPdf(){
          let devisDataPresta = JSON.stringify(this.devis['presta'])
          window.open("/PHP/pdf/devis.php?idDefunt=" + this.$route.params.id + "&devisPresta=" + devisDataPresta + "&token=" + this.$token(), "_blank")
        },
        createDevisDocX(){
          let devisDataPresta = JSON.stringify(this.devis['presta'])
             window.open("/PHP/docx/devis.php?idDefunt=" + this.$route.params.id + "&devisPresta=" + devisDataPresta + "&token=" + this.$token())
         },
        fetchData (){
          ajax_post(`/PHP/ajax/returnSaveDevis.php`,`choice=return&token=${this.$token()}&id=${this.$route.params.id}`).then((response) =>{
            let rep = JSON.parse(response)
            if(!rep.error){
              if(rep.data){
                rep.data.forEach(elem => {
                  if(elem.categorie=='Cercueil'){
                    this.devis.cercueil = elem.designation
                  }else if(elem.categorie=='Croix'){
                    this.devis.croix = elem.designation
                  }else if(elem.categorie=='Forfait'){
                    this.devis.forfait = elem.prix
                  }else{
                    if(!this.devis.prestaTiers.some(x => x.id == elem.id_field)){
                      this.devis.prestaTiers.push({categorie: elem.categorie, designation: elem.designation, remarque: elem.remarque, prix: elem.prix, id: elem.id_field, factPF: (elem.factPF==1 ? true : false)})
                    }
                  }
                })
              }
            }else{
              this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
            }
          })
        },
        addPresta(){
          if(this.prestaToAdd != ''){
            this.devis.presta.push({val: true, text: this.prestaToAdd})
            this.prestaToAdd = ''
          }
        },
        save(){
          setTimeout(() => {
            this.saveNext()
          }, 0)
        }
    },
    created () {
      this.fetchData()
    },
    watch: {
      'devis': {
        handler: function(){
          this.showButtonDevis = false
        },
        deep: true
      }
    }
}
</script>